// Blog/newsletter hosts that serve many unrelated publications from one domain (or its
// subdomains). Other feeds on such a domain say nothing about the feed under review, so they don't
// block auto-approval in the admin review flow.
const SHARED_HOSTING_DOMAINS = [
  'feedburner.com',
  'blogger.com',
  'blogspot.com',
  'substack.com',
  'wordpress.com',
  'follow.it',
  'medium.com',
  'ghost.io',
];

/** True if the domain (siteDomain() format: lowercase host without www.) is, or is a subdomain
 * of, a shared blog host such as substack.com. */
export const isSharedHostingDomain = (domain: string | undefined): boolean =>
  !!domain && SHARED_HOSTING_DOMAINS.some(d => domain == d || domain.endsWith(`.${d}`));
